var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:!_vm.disableButtonAnimation ? 'button-animation' : '',attrs:{"type":"submit","disabled":_vm.isLoading || _vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isLoading)?_c('span',{class:_vm.isBold ? 'bold-text' : ''},[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }